import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'core/translate';
import { Line, MathboxLine } from '../Lines';
import { invert } from '../utils';
import Currency from '../../../common/intl/Currency';

const TotalEmployeePriceGroup = ({ pricing, country }) => {
  const { eventDiscount, incentives } = pricing;
  if (!pricing.employeePrice) {
    return null;
  }

  if (country === 'US') {

    return (
      <>
        <div className="math-box-employee-price">
          <MathboxLine
            labelKey="total.employee.price"
            className="employee-discount-price"
            price={<Currency value={pricing.employeePrice} />}
          />
        </div>
        <Line
          labelKey="total.cash.allowances"
          value={invert(incentives.value)}
        />
        <Line
          label={<Translate value="event.discount" />}
          value={invert(eventDiscount)}
        />
      </>
    );
  }

  return (
    <div className="math-box-employee-price">
      <MathboxLine
        labelKey="total.employee.price"
        className="employee-discount-price"
        price={<Currency value={pricing.employeePrice} />}
      />
    </div>
  );
};

TotalEmployeePriceGroup.propTypes = {
  pricing: PropTypes.object.isRequired,
};

export default TotalEmployeePriceGroup;
